export default __webpack_public_path__ + "static/media/G0004.4bf1408e.png";